module.exports = __webpack_public_path__ + "img/金十期货@2x.82cd1ce9.png";